export const codeArr = [
    {
      code: `int numbers[5]; // Declaration of an integer array with 5 elements
float matrix[3][3]; // Declaration of a 2D array (matrix) with 3 rows and 3 columns`
    },
    {
      code: `struct Person {
      char name[50];
      int age;
      float height;
  };
  
struct Person john; // Declaration of a struct variable named "john"`
    },
    {
      code: `int* p; // Declaration of a pointer to an integer
float* q; // Declaration of a pointer to a float`
    },
    
  ];
  